import { persistSliceReducer } from "@overmap-ai/core"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import { ThemePalettes } from "../../enums/theme"
import { APP_DATA_DB_NAME } from "../constants"

export interface AppSettingsSliceState {
	appearance: "light" | "dark"
	themePalette: ThemePalettes
}

const initialState: AppSettingsSliceState = {
	appearance: "dark",
	themePalette: ThemePalettes.FUTURE,
}

export const appSettingsSlice = createSlice({
	name: "appSettings",
	initialState,
	reducers: {
		setAppearance: (state, action: PayloadAction<"dark" | "light">) => {
			state.appearance = action.payload
		},
		setThemePalette: (state, action: PayloadAction<ThemePalettes>) => {
			state.themePalette = action.payload
		},
	},
})

export const { setAppearance, setThemePalette } = appSettingsSlice.actions

export const appSettingsReducer = persistSliceReducer(appSettingsSlice, APP_DATA_DB_NAME)
